import { Component } from '@angular/core';

@Component({
  selector: 'app-headercomponent',
  imports: [],
  templateUrl: './headercomponent.html',
  styleUrl: './headercomponent.scss'
})
export class Headercomponent {

}
